{
  "nav": {
    "stats": "Statistics",
    "registerCatch": "Register catch",
    "myCatches": "My catches",
    "myFiskekort": "My fishing licences",
    "myBookings": "My bookings",
    "profile": "Profile",
    "login": "Log in",
    "logout": "Log out",
    "admin": "Admin",
    "valdAdmin": "Vald admin",
    "riverAdmin": "River admin",
    "history": "History",
    "buyFiskekort": "Buy fishing licence",
    "registerLink": "Create account",
    "loggFiskedag": "Log fishing day",
    "contact": "Contact us",
    "language": "Language",
    "fiskeHer": "Fishing here",
    "sectionFishing": "Fishing",
    "sectionExplore": "Explore",
    "sectionAccount": "My account",
    "sectionManagement": "Management",
    "sectionForOwners": "For owners",
    "sellFiskekort": "Sell fishing licences",
    "riverOwnersAssoc": "River owners' association",
    "photoContest": "Photo contest",
    "adminPhotoContest": "Photo contest (admin)",
    "menu": "Menu",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "privacy": "Privacy",
    "rivers": "Rivers & beats"
  },
  "stats": {
    "title": "Catch statistics",
    "filterYear": "Year",
    "filterMonth": "Month",
    "filterWeek": "Week",
    "filterDay": "Day",
    "totalCatches": "Total catches",
    "totalWeight": "Total weight",
    "avgWeight": "Average weight",
    "biggestFish": "Biggest fish",
    "released": "Released",
    "recentCatches": "Recent catches",
    "noData": "No catches in selected period",
    "allRivers": "All rivers",
    "allValds": "All valds",
    "viewVald": "View vald page →",
    "uniqueAnglers": "Anglers",
    "cpue": "Catches per angler",
    "registerCatchDesc": "Log the fish you caught with species, weight and length. Your name is not shown publicly by default.",
    "startFishingDesc": "Tap when you start fishing and “Done fishing” when you finish. We only store times, never your position.",
    "intro": "Lakseborsen is an open <b>salmon exchange</b> that gathers live <b>salmon statistics</b> from registered Norwegian salmon and sea trout rivers. See up-to-date catch figures for <b>{{year}}</b> — number of catches, total weight, average weight and biggest fish per river or beat. Go to <history>catch history</history> for seasons back to 2014."
  },
  "catch": {
    "title": "Register catch",
    "vald": "Vald (fishing zone)",
    "selectVald": "Select vald…",
    "fishType": "Fish type",
    "weight": "Weight (kg)",
    "weightKg": "Weight (kg)",
    "length": "Length (cm)",
    "lengthCm": "Length (cm)",
    "date": "Date",
    "time": "Time",
    "gear": "Gear",
    "photo": "Photo (optional)",
    "photoUploadFailed": "Photo upload failed",
    "released": "Released",
    "fromBoat": "From a boat",
    "sex": "Sex (optional)",
    "sexTypes": {
      "hann": "Male",
      "hunn": "Female"
    },
    "seaLice": "Sea lice",
    "fisher": "Angler",
    "roer": "Rower",
    "onBehalf": {
      "question": "Who is this catch for?",
      "self": "Myself",
      "other": "Another angler",
      "fisherName": "Angler's name",
      "fisherNamePlaceholder": "Enter name",
      "recent": "Recently used"
    },
    "conditions": "Conditions at catch time",
    "airTemp": "Air temperature",
    "precipitation": "Precipitation",
    "windSpeed": "Wind speed",
    "waterTemp": "Water temperature",
    "waterFlow": "Water flow",
    "nveStationSource": "Source: {{station}}",
    "weatherPending": "Weather data available in approx. 5 days",
    "submit": "Register",
    "submitting": "Saving…",
    "success": "Catch registered!",
    "offlineDraft": "Saved locally — will be sent automatically when you're online",
    "fishTypes": {
      "laks": "Atlantic salmon",
      "brunørret": "Brown trout",
      "sjøørret": "Sea trout",
      "pukkellaks": "Pink salmon",
      "oppdrettslaks": "Farmed salmon",
      "støing": "Kelt",
      "røye": "Arctic char",
      "ørret": "Sea trout"
    },
    "gearTypes": {
      "flue": "Fly fishing",
      "wobbler": "Wobbler",
      "spinner": "Spinner",
      "sluk": "Spoon",
      "mark_orm": "Worm / bait",
      "rapala": "Rapala",
      "annet": "Other"
    },
    "errors": {
      "valdRequired": "Please select a vald (fishing zone)",
      "weightInvalid": "Weight must be between 0.1 and 100 kg",
      "lengthInvalid": "Length must be between 5 and 250 cm",
      "dateRequired": "Please enter a valid date and time",
      "fisherNameRequired": "Please enter the angler's name"
    },
    "fishingDayPrompt": "Fished today without a catch?",
    "logFishingDay": "Log fishing day",
    "logFishingDayDone": "Fishing day logged ✓",
    "edit": "Edit",
    "editTitle": "Edit catch",
    "editSave": "Save changes",
    "editSaved": "Catch updated!",
    "locate": {
      "button": "Use my location",
      "locating": "Finding your location…",
      "found": "Found nearest vald: {{vald}}",
      "unsupported": "Location isn't supported in this browser",
      "denied": "You need to allow location access to use this",
      "failed": "Couldn't get your location",
      "noneFound": "No nearby valds have location data yet"
    },
    "photoPendingOffline": "The photo will upload automatically once you're back online",
    "photoChange": "Change photo",
    "photoAdd": "Add photo",
    "photoPreviewAlt": "Preview",
    "fishingDayOffline": "Saved locally — will be logged automatically when you're online",
    "showNamePublic": "Show my name publicly",
    "showNamePublicDesc": "Off by default. The catch counts in statistics either way."
  },
  "bulk": {
    "title": "Register small fish (bulk)",
    "intro": "Caught many small trout? Register them all at once instead of one by one.",
    "count": "Number of fish",
    "countHint": "Registering {{count}} fish",
    "allReleased": "All released",
    "optionalMeasurements": "Optional measurements (leave blank if unknown)",
    "avgWeight": "Average weight (kg)",
    "avgLength": "Average length (cm)",
    "lengthHint": "Typically under 40 cm",
    "submit": "Register {{count}} fish",
    "submitting": "Registering…",
    "success": "{{count}} fish registered!",
    "successDetail": "The catches have been saved and will appear in statistics.",
    "registerMore": "Register more",
    "backToForm": "Standard registration",
    "bulkLink": "Caught many small trout? → Bulk registration",
    "errors": {
      "countInvalid": "Count must be between 1 and 50"
    },
    "decreaseCount": "Decrease",
    "increaseCount": "Increase"
  },
  "myCatches": {
    "title": "My catches",
    "empty": "You haven't registered any catches yet.",
    "registerFirst": "Register your first catch",
    "exportCsv": "Download my catches",
    "exportError": "Failed to download catches"
  },
  "profile": {
    "title": "My profile",
    "displayName": "Name",
    "language": "Language",
    "save": "Save",
    "saved": "Saved!",
    "security": "Security",
    "passkey": "Passkey (biometric login)",
    "passkeyDesc": "Sign in quickly with fingerprint, face recognition or a security key.",
    "registerPasskey": "Register passkey",
    "addPasskey": "Add another passkey",
    "passkeyDefaultLabel": "Passkey",
    "passkeyAdded": "Added {{date}}",
    "deletePasskey": "Delete",
    "confirmDeletePasskey": "Delete passkey \"{{label}}\"?",
    "hideNamePublic": "Show my catches anonymously",
    "hideNamePublicDesc": "Your name will be hidden from public catch feeds. Your catches will still count in statistics.",
    "deleteAccount": "Delete account",
    "deleteAccountDesc": "Removes your name, email and other personal details from your profile. Your catches are kept, anonymised, as required by law for catch reporting.",
    "confirmDeleteAccount": "Are you sure you want to delete your account? This cannot be undone.",
    "privacy": "Privacy",
    "privacyDesc": "Download all the data we hold about you. See also the privacy policy (Norwegian).",
    "exportData": "Download my data"
  },
  "admin": {
    "title": "Admin dashboard",
    "totalCatches": "Total catches",
    "catchesThisYear": "Catches this year",
    "totalFishers": "Active anglers",
    "totalUsers": "Registered users",
    "tabCatches": "Catches",
    "tabUsers": "Users",
    "dateFrom": "From date",
    "dateTo": "To date",
    "allFishTypes": "All fish types",
    "allReleased": "All (released)",
    "keptOnly": "Kept only",
    "releasedOnly": "Released only",
    "applyFilters": "Filter",
    "resetFilters": "Reset",
    "catchCount": "{{count}} catches",
    "exportCsv": "Download CSV",
    "deleteSelected": "Delete selected ({{count}})",
    "confirmBulkDeleteCatches": "Delete {{count}} catch(es)? This cannot be undone.",
    "bulkDeleteDone": "{{count}} catch(es) deleted.",
    "selectAllOnPage": "Select all on page",
    "selectRow": "Select row",
    "fisher": "Angler",
    "yes": "Yes",
    "no": "No",
    "prevPage": "Previous",
    "nextPage": "Next",
    "userName": "Name",
    "userEmail": "Email",
    "userRole": "Role",
    "userCatches": "Catches",
    "registered": "Registered",
    "role_fisher": "Angler",
    "role_admin": "Admin",
    "promote": "Make admin",
    "demote": "Remove admin",
    "tabValds": "Beats",
    "tabRivers": "Rivers",
    "searchRiver": "Search river (name, municipality, system)…",
    "edit": "Edit",
    "riverName": "Name",
    "riverSystem": "System",
    "riverMunicipalities": "Municipality",
    "riverSeason": "Season",
    "riverFlags": "Status",
    "riverMain": "Main river",
    "riverClosed": "Temporarily closed",
    "riverRequiresDisinfection": "Requires disinfection",
    "riverDescription": "Description",
    "riverFishingRules": "Fishing rules",
    "riverSeasonOpen": "Season opens (MM-DD)",
    "riverSeasonClose": "Season closes (MM-DD)",
    "riverNveId": "NVE station ID",
    "riverNveName": "NVE station name",
    "valdName": "Beat",
    "valdRiver": "River",
    "valdOwner": "Owner",
    "valdNoOwner": "No owner",
    "assignOwner": "Assign owner",
    "clearOwner": "Clear owner",
    "searchVald": "Search zone…",
    "searchUser": "Search user (name or email)…",
    "search": "Search",
    "select": "Select",
    "filterRiver": "Filter by river",
    "allRivers": "All rivers",
    "searchUsers": "Search by name or email…",
    "ownedValds": "Valds",
    "selectVald": "Select vald…",
    "assignVald": "Assign vald",
    "removeValdOwner": "Remove ownership",
    "role_river_admin": "River admin",
    "promoteRiverAdmin": "Make river admin",
    "demoteRiverAdmin": "Remove river admin",
    "selectRiver": "Select river…",
    "selectRiverSystem": "Select river system…",
    "makeRiverAdmin": "Make river admin",
    "inviteOwner": "Invite beat owner",
    "inviteHint": "Enter the email address of the future beat owner.",
    "inviteEmailPlaceholder": "Owner's email",
    "sendInvite": "Send invitation",
    "inviteSentOk": "Invitation sent to {{email}}",
    "inviteAssignedDirect": "{{email}} is already a user and was assigned ownership",
    "pendingInvite": "Awaiting {{email}}"
  },
  "riverAdmin": {
    "title": "River admin",
    "totalCatches": "Total catches",
    "catchesThisYear": "Catches this year",
    "allYears": "All years",
    "exportCsv": "Download Excel",
    "exportError": "Failed to download Excel",
    "tabs": {
      "fangster": "Catches",
      "valds": "Valds",
      "elver": "Rivers",
      "meldinger": "Messages",
      "vilkar": "Terms",
      "rettelser": "Corrections",
      "fisketrykk": "Fishing pressure",
      "elvekort": "Elvekort"
    },
    "rivers": {
      "title": "Season & closures",
      "hint": "Set season dates per river. Temporary closure is shown to fishers.",
      "seasonOpen": "Season opens",
      "seasonClose": "Season closes",
      "month": "Month",
      "day": "Day",
      "temporarilyClosed": "Temporarily closed",
      "temporarilyClosedHint": "Shows a 'Temporarily closed' warning on the public river page. Anglers can still register catches and purchase fishing cards.",
      "requiresDisinfection": "Requires disinfection",
      "requiresDisinfectionHint": "Fishers must confirm disinfection method when purchasing a permit",
      "save": "Save",
      "saved": "Saved ✓",
      "description": "Description (shown publicly)",
      "descriptionPlaceholder": "Write a short description of the river…",
      "municipalities": "Municipality",
      "municipalitiesPlaceholder": "e.g. Røyrvik, Namsskogan, Grong, Overhalla, Namsos",
      "municipalitiesHint": "Shown in SEO metadata and on the river page. Editable by site admin only.",
      "fishingRules": "Fishing regulations (text, shown publicly)",
      "fishingRulesPlaceholder": "Enter regulations, restrictions, and other info fishers need to know…",
      "images": "Images (shown on the river page)",
      "addPhoto": "+ Add image",
      "stayGuide": "How to stay here (text, shown publicly)",
      "stayGuidePlaceholder": "Tips on how anglers can best stay: nearest town, what to book early, places to eat, gear rental…",
      "nearbyPlaces": "Hotels and restaurants nearby",
      "placeName": "Name",
      "placeDistance": "Distance, e.g. \"5 min from Formofoss\"",
      "placeDescription": "Short description",
      "addPlace": "+ Add place",
      "seasonEvents": "What's happening this season (events)",
      "eventTitle": "Title",
      "eventStart": "Start date",
      "eventEnd": "End date (optional)",
      "eventDescription": "Short description",
      "addEvent": "+ Add event",
      "placeLat": "Latitude (optional)",
      "placeLon": "Longitude (optional)",
      "placeHighlight": "Text from the sponsor (shown as sponsored content)",
      "placeTags": "Offers",
      "placeSponsor": "Supports the river (sponsor)",
      "placePick": "Recommended? Say why (shown as “Recommended by the river association”)",
      "placeLogo": "Logo (optional)",
      "sponsorReport": "Sponsor report",
      "sponsorReportMonth": "Month",
      "sponsorReportLinks": "Link clicks",
      "sponsorReportMap": "Show on map",
      "sponsorReportCopy": "Copy text",
      "sponsorReportCopied": "Copied",
      "sponsorReportHint": "Counts clicks on the sponsor link and “Show on map”. No personal data is stored.",
      "sponsorReportText": "{{name}}: in {{month}} your link was clicked {{link}} times and “Show on map” was used {{map}} times on the river guide.",
      "sub": {
        "season": "Season",
        "content": "Content",
        "nearby": "Nearby",
        "sponsors": "Sponsors"
      },
      "selectRiver": "Select river",
      "systemPlacesNote": "Applies to every river in {{system}}. Add a place once and it shows on all the rivers.",
      "sponsorReportEmpty": "No sponsors yet. Under “Nearby” you can tick “Supports the river (sponsor)” on a listing. Sponsors then appear here with their clicks per month.",
      "placeFamily": "For the whole family (also non-anglers)",
      "placePhone": "Phone",
      "placeImage": "Photo (sponsor)",
      "sponsorTier_none": "No sponsor",
      "sponsorTier_friend": "Friend of the river",
      "sponsorTier_local": "Local support",
      "sponsorTier_supporter": "Supporter",
      "sponsorTier_partner": "Partner",
      "sponsorTier_main": "Main sponsor"
    },
    "valds": {
      "title": "Valds",
      "ownerLabel": "Owner",
      "noOwner": "No owner",
      "assignOwner": "Change owner",
      "clearOwner": "Remove owner",
      "searchUsers": "Search for user (name or email)…"
    },
    "messaging": {
      "title": "Send message",
      "recipients": "Recipients",
      "recipientValdeiere": "Vald owners",
      "recipientFishers": "Fishers",
      "recipientAll": "All",
      "subject": "Subject",
      "body": "Message",
      "send": "Send message",
      "sending": "Sending…",
      "sent": "Sent to {{count}} recipients",
      "sentCount": "Sent count",
      "history": "Sent messages",
      "empty": "No messages sent yet",
      "recipientCustom": "Individuals",
      "emailToggle": "Also send by email ({{count}} with email)",
      "previewCount": "{{count}} recipients",
      "noRecipients": "No recipients found",
      "sendBtn": "Send to {{count}} recipients"
    }
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark all as read",
    "empty": "No notifications",
    "typeMessageReceived": "New message",
    "typeValdOwnerAssigned": "Vald assigned"
  },
  "common": {
    "loading": "Loading…",
    "noResults": "No results",
    "error": "Something went wrong",
    "retry": "Try again",
    "kg": "kg",
    "cm": "cm",
    "back": "Back",
    "clear": "Clear",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "paymentMethods": "We accept Vipps, card (Visa/Mastercard) and MobilePay.",
    "previousMonth": "Previous month",
    "nextMonth": "Next month"
  },
  "auth": {
    "loginRequired": "Log in to continue",
    "loginForCatch": "Log in to register a catch",
    "loginForMyCatches": "Log in to view your catches",
    "loginForProfile": "Log in to view your profile",
    "loginHint": "You can sign in with Google, email link, or password",
    "registerHint": "New user?",
    "registerLink": "Create account"
  },
  "history": {
    "title": "Catch history",
    "year": "Year",
    "week": "Week",
    "weekLabel": "Week {{week}}",
    "allWeeks": "All weeks",
    "colTime": "Time",
    "colFish": "Fish type",
    "colWeight": "Weight",
    "colLength": "Length",
    "colGear": "Gear",
    "colVald": "Vald",
    "colFisher": "Angler",
    "colReleased": "Released"
  },
  "valdPage": {
    "river": "River",
    "owner": "Owner",
    "noOwner": "Not available",
    "catchesThisYear": "Catches this year",
    "fiskekortTitle": "Fishing permits",
    "noFiskekort": "No fishing permits available for this beat",
    "loginToBook": "Log in to purchase a fishing permit",
    "buy": "Buy",
    "price": "Price",
    "durationDay": "{{count}} day",
    "durationDays": "{{count}} days",
    "seasonLabel": "Season",
    "unlimited": "Unlimited",
    "available": "Available",
    "remaining": "{{count}} available",
    "soldOut": "Sold out",
    "seasonOpens": "Season opens {{date}}",
    "seasonEnded": "Season has ended",
    "preBook": "Pre-book",
    "packagesTitle": "Packages",
    "noPackages": "No packages available",
    "packageIncludes": "Includes",
    "combinedPrice": "Combined price: {{price}} kr",
    "orderPackageBtn": "Order package",
    "accommodationTitle": "Accommodation",
    "accommodationNoCardRequired": "No fishing permit required – anyone can book accommodation.",
    "noAccommodation": "No accommodation available",
    "capacity": "{{count}} person",
    "capacity_plural": "{{count}} people",
    "perNight": "/ night",
    "book": "Book accommodation",
    "accommodationType_hytte": "Cabin",
    "accommodationType_rom": "Room",
    "accommodationType_telt": "Tent pitch",
    "accommodationType_campingvogn": "Caravan",
    "accommodationType_annet": "Other",
    "fishingSpotsTitle": "Fishing spots",
    "omOssTitle": "About us",
    "contactPhone": "Phone",
    "contactEmail": "Email",
    "contactWebsite": "Website",
    "tilgjengelighet": "Accessibility",
    "avstandBilvei": "Distance to road",
    "editVald": "Edit beat",
    "seePermits": "View fishing permits"
  },
  "fiskekort": {
    "purchaseTitle": "Buy fishing permit",
    "product": "Product",
    "vald": "Beat",
    "validFrom": "First day",
    "validTo": "Valid until",
    "price": "Price",
    "confirm": "Confirm purchase",
    "submitting": "Buying…",
    "success": "Fishing permit purchased!",
    "successDescription": "Your permit is now active. Find it under My fishing permits.",
    "viewMyCards": "View my fishing permits",
    "currency": "NOK",
    "paymentProcessing": "Processing payment…",
    "paymentCancelled": "Payment cancelled",
    "paymentCancelledDesc": "You can try purchasing the permit again.",
    "paymentPending": "Payment received",
    "paymentPendingDesc": "We are waiting for confirmation from the payment provider. Your permit will appear under My fishing permits once confirmed.",
    "seasonNote": "Season: {{open}} – {{close}}",
    "errorBeforeSeason": "Selected date is outside the season. The season opens {{open}}.",
    "errorAfterSeason": "The permit extends past the season end ({{close}}). Please choose an earlier start date.",
    "disinfectionTitle": "Disinfection (required)",
    "disinfectionHint": "This river requires you to confirm that your equipment and/or boat has been disinfected in accordance with regulations.",
    "disinfectionRequired": "You must select a disinfection method.",
    "disinfectionMethod": {
      "dried_2weeks": "Dried for at least 2 weeks",
      "frozen": "Frozen",
      "heat_treated": "Heat-treated (at least 60 °C)",
      "chemical": "Chemically disinfected"
    },
    "quantity": "Number of permits",
    "totalPrice": "Total price"
  },
  "myFiskekort": {
    "title": "My fishing permits",
    "empty": "You have no fishing permits yet.",
    "validFrom": "From",
    "validTo": "Until",
    "status": "Status",
    "status_confirmed": "Active",
    "status_cancelled": "Cancelled",
    "status_pending": "Pending",
    "vald": "Beat",
    "product": "Type",
    "price": "Paid",
    "bookAgain": "Book again →",
    "showProof": "Show permit",
    "registerCatch": "Register catch"
  },
  "myBookings": {
    "title": "My bookings",
    "empty": "You have no bookings yet.",
    "listing": "Accommodation",
    "checkIn": "Check-in",
    "checkOut": "Check-out",
    "guests": "Guests",
    "total": "Total",
    "status_confirmed": "Confirmed",
    "status_cancelled": "Cancelled",
    "status_pending": "Pending",
    "cancelBtn": "Cancel booking",
    "cancelConfirm": "Are you sure you want to cancel this booking?",
    "cancelling": "Cancelling…",
    "cancelError": "Could not cancel. Please try again.",
    "refundNote": "Booking cancelled. Any refund will be processed manually within 5 business days."
  },
  "valdAdmin": {
    "title": "Beat administration",
    "myValds": "My beats",
    "selectVald": "Select a beat to manage",
    "searchVald": "Search zone…",
    "catchesThisYear": "Catches this year",
    "totalCatches": "Total catches",
    "fiskekortTitle": "Fishing permits",
    "addProduct": "Add permit",
    "editProduct": "Edit",
    "deactivateProduct": "Deactivate",
    "noProducts": "No fishing permits configured yet",
    "description": "Description (shown on public beat page)",
    "savedDescription": "Saved!",
    "saveDescription": "Save description",
    "purchasesTitle": "Sold permits",
    "noPurchases": "No sales recorded yet",
    "productName": "Name",
    "productPrice": "Price (øre)",
    "productDuration": "Duration (days)",
    "productSeasonStart": "Season start (YYYY-MM-DD)",
    "productSeasonEnd": "Season end (YYYY-MM-DD)",
    "productQuota": "Quota (blank = unlimited)",
    "save": "Save",
    "cancel": "Cancel",
    "saving": "Saving…",
    "confirmDeactivate": "Deactivate this product?",
    "confirmForceDeleteProduct": "Product has confirmed purchases. Delete permanently (including all purchases)? This cannot be undone.",
    "purchaseFisher": "Angler",
    "purchaseProduct": "Product",
    "purchaseValid": "Valid",
    "purchaseStatus": "Status",
    "purchasePaid": "Paid",
    "backToValds": "Back to beat overview",
    "viewPublicPage": "View public page",
    "tabFiskekort": "Fishing permits",
    "tabAccommodation": "Accommodation",
    "tabPackages": "Packages",
    "tabSettings": "Settings",
    "tabRevenue": "Revenue",
    "addListing": "Add accommodation",
    "editListing": "Edit",
    "deactivateListing": "Deactivate",
    "activateListing": "Activate",
    "managePhotos": "Photos",
    "addPhoto": "Add photo",
    "deletePhoto": "Delete photo",
    "uploadingPhoto": "Uploading...",
    "confirmDeletePhoto": "Delete this photo?",
    "noListings": "No accommodation listings yet",
    "listingName": "Name",
    "listingType": "Type",
    "listingCapacity": "Capacity (persons)",
    "listingPrice": "Price per night (øre)",
    "listingDesc": "Description",
    "listingProximityNote": "Proximity to fishing beat",
    "listingProximityNotePlaceholder": "e.g. 5 min drive from Formofoss zone 2",
    "listingOpenFrom": "Open from (MM-DD)",
    "listingOpenTo": "Open until (MM-DD)",
    "listingMinNights": "Min. nights",
    "listingMaxNights": "Max. nights",
    "blockedPeriods": "Blocked periods",
    "noBlockedPeriods": "No blocked periods.",
    "addBlockedPeriod": "Add block",
    "blockedFrom": "From",
    "blockedTo": "To",
    "blockedReason": "Reason (optional)",
    "blockedReasonHint": "e.g. Maintenance",
    "bookingsTitle": "Booking requests for {{name}}",
    "noBookings": "No booking requests",
    "bookingGuest": "Guest",
    "bookingDates": "Dates",
    "bookingStatus": "Status",
    "bookingConfirm": "Confirm",
    "bookingCancel": "Decline",
    "bookingStatus_pending": "Pending",
    "bookingStatus_confirmed": "Confirmed",
    "bookingStatus_cancelled": "Declined",
    "addPackage": "Add package",
    "editPackage": "Edit",
    "deletePackage": "Delete",
    "noPackages": "No packages yet",
    "packageName": "Name",
    "packageDesc": "Description",
    "packageFiskekort": "Fishing permit (optional)",
    "packageAccommodation": "Accommodation (optional)",
    "packageCombinedPrice": "Combined price in øre (optional)",
    "packageNone": "— none —",
    "contactTitle": "Contact info (About us)",
    "contactName": "Name / organisation",
    "contactPhone": "Phone",
    "contactEmail": "Email",
    "contactWebsite": "Website",
    "saveContact": "Save contact info",
    "fishingOptionsTitle": "Fishing options",
    "suitableForFlyFishing": "Suitable for fly fishing",
    "fishingFromBoat": "Boat fishing available",
    "saveFishingOptions": "Save fishing options",
    "seasonPicker": {
      "yearRound": "Year-round",
      "yearRoundNote": "Available all year",
      "selectStart": "Click to select start date",
      "selectEnd": "select end date"
    },
    "calendarPreview": "Show calendar preview",
    "calendarPreviewHide": "Hide calendar preview",
    "setupChecklist": {
      "title": "Getting started – set up your vald",
      "step1": "Describe the vald",
      "step2": "Add a fishing permit product",
      "step3": "Add accommodation",
      "step4": "Create a package",
      "optional": "optional",
      "packageHint": "Create a fishing permit product and an accommodation listing first before creating a package."
    }
  },
  "accommodation": {
    "bookTitle": "Book accommodation",
    "listing": "Accommodation",
    "checkIn": "Check-in",
    "checkOut": "Check-out",
    "guestCount": "Number of guests",
    "guestName": "Your name",
    "guestEmail": "Email",
    "guestPhone": "Phone (optional)",
    "notes": "Message to owner (optional)",
    "totalPrice": "Total price",
    "totalNights": "{{count}} night",
    "totalNights_plural": "{{count}} nights",
    "bookBtn": "Send booking request",
    "submitting": "Sending…",
    "success": "Request sent!",
    "successDetail": "The owner will contact you to confirm.",
    "loginRequired": "You must be logged in to book accommodation",
    "perNight": "/ night",
    "datesUnavailable": "These dates are not available, please choose different dates",
    "paymentProcessing": "Processing payment…",
    "paymentConfirmed": "Payment confirmed!",
    "paymentConfirmedDesc": "Your booking is confirmed. We look forward to seeing you!",
    "paymentCancelled": "Payment cancelled",
    "paymentCancelledDesc": "The payment was cancelled. You can try again.",
    "paymentPending": "Payment pending",
    "paymentPendingDesc": "Payment not yet confirmed. Check My bookings shortly.",
    "viewMyBookings": "View my bookings",
    "unavailablePeriods": "Booked periods",
    "blockedPeriods": "Blocked periods",
    "seasonWindow": "Season open {{from}} – {{to}}",
    "minNightsHint": "Minimum {{count}} nights",
    "maxNightsHint": "Maximum {{count}} nights",
    "minNightsError": "At least {{count}} nights required",
    "maxNightsError": "Maximum {{count}} nights allowed",
    "outsideSeason": "Selected dates are outside the open season"
  },
  "fiskekortList": {
    "title": "Available fishing licences",
    "intro": "Browse and buy fishing licences",
    "noProducts": "No fishing licences available at the moment",
    "buy": "Buy",
    "soldOut": "Sold out",
    "unlimited": "Unlimited",
    "remaining": "{{count}} left",
    "durationDay": "1 day",
    "durationDays": "{{count}} days",
    "calendarView": "Calendar",
    "listView": "List",
    "noProductsDay": "No fishing licences available on this day",
    "legendAvailable": "Available",
    "legendSoldOut": "Sold out"
  },
  "fishingDay": {
    "title": "Log fishing day",
    "intro": "Register that you fished today without catching anything.",
    "submit": "Log fishing day",
    "submitting": "Logging…",
    "success": "Fishing day logged!",
    "successCta": "Want to register a catch?",
    "calendarTitle": "Your fishing days",
    "noCatches": "no catch",
    "catchCount_one": "{{count}} catch",
    "catchCount_other": "{{count}} catches",
    "delete": "Remove",
    "confirmDelete": "Remove this fishing day?"
  },
  "contact": {
    "title": "Contact us",
    "intro": "Have a question or feedback? Send us a message and we’ll get back to you as soon as possible.",
    "name": "Name",
    "email": "Email address",
    "message": "Message",
    "send": "Send message",
    "sending": "Sending...",
    "successMessage": "Thank you! We’ve received your message and will reply shortly.",
    "errorMessage": "Something went wrong. Please try again or email noreply@lakseborsen.no directly."
  },
  "revenue": {
    "title": "Revenue",
    "year": "Year",
    "fiskekortTotal": "Fishing licences",
    "bookingsTotal": "Accommodation",
    "grandTotal": "Total",
    "fiskekortSales": "Fishing licence sales",
    "accommodationBookings": "Accommodation bookings",
    "noData": "No data for selected year.",
    "exportCsv": "Download CSV",
    "product": "Product",
    "date": "Date",
    "amount": "Amount",
    "listing": "Listing",
    "checkIn": "Check-in",
    "checkOut": "Check-out",
    "guest": "Guest",
    "payoutStatus": "Paid out",
    "payoutDone": "Yes",
    "payoutPending": "No"
  },
  "packageOrder": {
    "title": "Order package",
    "priceBreakdown": "Price breakdown",
    "fiskekortPart": "Fishing permit",
    "accommodationPart": "Accommodation",
    "combinedTotal": "Combined price",
    "validFrom": "Permit start (check-in)",
    "checkIn": "Check-in",
    "checkOut": "Check-out",
    "guestCount": "Number of guests",
    "guestName": "Your name",
    "guestEmail": "Email",
    "guestPhone": "Phone (optional)",
    "notes": "Message (optional)",
    "submitBtn": "Order and pay",
    "submitting": "Sending…",
    "paymentProcessing": "Processing payment…",
    "paymentConfirmed": "Package ordered!",
    "paymentConfirmedDesc": "Fishing permit and accommodation confirmed. Tight lines!",
    "paymentPending": "Payment pending",
    "paymentPendingDesc": "Payment not yet confirmed. Check My orders shortly.",
    "paymentCancelled": "Payment cancelled",
    "paymentCancelledDesc": "You can try again.",
    "viewMyBookings": "View my bookings",
    "loginRequired": "You must log in to order a package"
  },
  "riverPage": {
    "notFound": "River not found",
    "temporarilyClosed": "Temporarily closed",
    "requiresDisinfection": "Disinfection required",
    "packagesSection": "Packages — fishing permit + accommodation",
    "valdsSection": "Fishing zones and permits",
    "accommodationSection": "Accommodation",
    "viewVald": "View zone",
    "noValds": "No zones registered",
    "noProductsForVald": "No cards available",
    "mapSection": "River map",
    "fishingRulesTitle": "Fishing regulations",
    "eventsSection": "What's happening this season",
    "staySection": "Stay, eat and explore at {{name}}",
    "readMore": "Read more",
    "placeCategory_hotel": "Hotel",
    "placeCategory_restaurant": "Restaurant",
    "placeCategory_camping": "Camping",
    "placeCategory_cabin": "Cabins",
    "placeCategory_shop": "Shop",
    "placeCategory_other": "Other",
    "filterValds": "Search beats…",
    "noValdMatch": "No beats match your search",
    "fromPrice": "from {{price}}",
    "cardCount_one": "{{count}} permit",
    "cardCount_other": "{{count}} permits",
    "noCardsAvailable": "No permits available",
    "showAllValds": "Show all {{count}} beats",
    "seePermits": "View fishing permits",
    "nearbyFilter_all": "All",
    "nearbyFilter_stay": "Stay",
    "nearbyFilter_eat": "Eat",
    "nearbyFilter_shop": "Shops",
    "nearbyFilter_other": "Other",
    "nearbyNear": "Closest to",
    "nearbyNearNone": "None selected",
    "nearbyDistance": "{{km}} km as the crow flies from {{vald}}",
    "nearbyBookable": "Bookable here",
    "nearbyAd": "Sponsored content",
    "nearbyTag_fiskekort": "Sells fishing licences",
    "nearbyTag_tackle": "Tackle",
    "nearbyTag_guide": "Guide",
    "nearbyTag_boat": "Boat rental",
    "nearbyTag_drying": "Drying room",
    "nearbyTag_freezer": "Freezer",
    "nearbyTag_earlyBreakfast": "Early breakfast",
    "mapLayer_valds": "Valds",
    "mapLayer_spots": "Fishing spots",
    "nearbySponsor": "Supports {{river}}",
    "nearbyPick": "Recommended by the river association",
    "nearbyShowOnMap": "Show on map",
    "sponsorsRow": "Supported by",
    "placeCategory_attraction": "Attraction",
    "nearbyFilter_see": "Things to do",
    "nearbyFilter_family": "Family",
    "nearbyFamily": "For the whole family",
    "nearbyVisit": "Visit website",
    "nearbyCall": "Call",
    "sponsorMain": "Main sponsor"
  },
  "fiskekortBevis": {
    "statusActive": "Active — permit valid",
    "refLabel": "Ref",
    "print": "Print / Share",
    "catchCtaText": "Caught something? Remember to register your catch!",
    "catchCtaBtn": "Register catch"
  },
  "discovery": {
    "title": "Find fishing permits for Norwegian salmon rivers",
    "intro": "Browse beats and buy fishing permits from beat owners selling on Lakseborsen. Filter by river, fishing technique or availability.",
    "filterRiver": "Filter by river",
    "allRivers": "All rivers",
    "flyFishing": "Fly fishing",
    "boatFishing": "Boat fishing",
    "hasFiskekort": "Fishing permit",
    "clearFilters": "Clear filters",
    "resultCount": "{{count}} beats",
    "noResults": "No beats match the filter.",
    "buyFiskekort": "Buy permit",
    "seeVald": "See beat",
    "searchPlaceholder": "Search for a beat or river",
    "sortLabel": "Sort",
    "sortName": "Name (A-Z)",
    "sortPrice": "Price"
  },
  "bliValdeier": {
    "title": "Become a beat owner",
    "lead": "You have been invited to become beat owner for {{valdName}} on {{riverName}}.",
    "vald": "Beat",
    "river": "River",
    "loginHint": "Log in with the account registered on the invited email to accept.",
    "loginAndAccept": "Log in and accept",
    "autoClaimHint": "Completing registration...",
    "claiming": "Registering ownership...",
    "successTitle": "Welcome as beat owner!",
    "successDesc": "You are now registered as owner of {{valdName}}.",
    "goToValdAdmin": "Go to beat admin",
    "notFoundTitle": "Invitation not found",
    "notFoundDesc": "The link is invalid or expired.",
    "expiredTitle": "Invitation expired",
    "expiredDesc": "Ask the administrator to send a new invitation.",
    "claimedTitle": "Already used",
    "claimedDesc": "This invitation has already been accepted.",
    "errorTitle": "Something went wrong"
  },
  "komIGang": {
    "selectVald": "Select beat",
    "chooseVald": "Choose a beat",
    "step1Title": "Contact information",
    "step1Desc": "Enter contact details and a description of the beat. This is shown publicly.",
    "contactName": "Contact person",
    "contactNamePlaceholder": "Name or organisation",
    "phone": "Phone",
    "email": "Email",
    "website": "Website",
    "description": "Description",
    "descriptionPlaceholder": "Tell about the beat, fishing conditions, rules etc.",
    "step2Title": "Map and fishing modes",
    "step2Desc": "Place the beat on the map, draw boundaries and choose fishing techniques.",
    "mapLocation": "Map position (click to place)",
    "polygon": "Beat boundary (optional)",
    "flyFishing": "Suitable for fly fishing",
    "boatFishing": "Fishing from boat possible",
    "step3Title": "Fishing spots",
    "step3Desc": "Add specific fishing spots on the map (optional).",
    "step3Hint": "You can add fishing spots from the beat admin panel at any time.",
    "back": "Back",
    "nextStep": "Next step",
    "skipWizard": "Skip",
    "goToValdAdmin": "Go to beat admin"
  },
  "installPrompt": {
    "text": "Add Lakseborsen to your home screen for faster access",
    "iosHint": "Add Lakseborsen to your home screen: open the Share menu in your browser and choose \"Add to Home Screen\".",
    "install": "Add",
    "dismiss": "Close"
  },
  "textSize": {
    "label": "Text size",
    "normal": "Normal text size",
    "large": "Large text size",
    "xlarge": "Extra large text size"
  },
  "statsSection": {
    "title": "Statistics and charts",
    "yearLabel": "Season",
    "tooFewData": "More data is needed to show this chart",
    "noCatchesForYear": "No catches registered this season",
    "loading": "Loading statistics…",
    "axisCatches": "Catches",
    "axisAvgWeight": "Average weight (kg)",
    "axisWeek": "Week",
    "axisHour": "Hour",
    "kpi": {
      "totalCatches": "Total catches",
      "totalWeight": "Total weight",
      "avgWeight": "Average weight",
      "biggestFish": "Biggest fish",
      "releaseRate": "Release rate",
      "uniqueAnglers": "Active anglers",
      "cpue": "Catches per angler",
      "fishingHours": "Fishing hours",
      "catchesPerHour": "Catch per hour",
      "anglersNow": "Anglers now"
    },
    "fishType": {
      "title": "Catch distribution by species",
      "subtitle": "Number of catches per species"
    },
    "gear": {
      "title": "Which gear catches the most?",
      "subtitle": "Catches by gear type"
    },
    "weekly": {
      "title": "When in the season is fishing best?",
      "subtitle": "Catches per week"
    },
    "hour": {
      "title": "What time of day do they bite?",
      "subtitle": "Catches per hour of day"
    },
    "airTemp": {
      "title": "Air temperature and catches",
      "subtitle": "Number of catches and average weight per temperature"
    },
    "waterTemp": {
      "title": "Water temperature and catches",
      "subtitle": "Number of catches and average weight per temperature"
    },
    "waterFlow": {
      "title": "Water flow and catches",
      "subtitle": "Number of catches and average weight per flow level"
    },
    "historicalHeader": "Historical overview",
    "yearly": {
      "title": "Catches per season",
      "subtitle": "Total registered catches, year by year"
    },
    "typical": {
      "title": "Typical season vs. this year",
      "subtitle": "Weekly average based on {{yearCount}} historical seasons",
      "avgLabel": "Average",
      "currentLabel": "{{year}}"
    },
    "biggest": {
      "title": "Biggest catches of all time",
      "subtitle": "Top 10 — click to view the catch"
    },
    "showAllCharts": "Show all charts"
  },
  "notFound": {
    "title": "Page not found",
    "message": "We couldn't find the page you were looking for.",
    "backHome": "Back to home"
  },
  "terms": {
    "title": "Fishing terms",
    "accept": "I have read and accept the terms",
    "mustAccept": "You must accept the terms to continue.",
    "translationNote": "This is a translation. If there is any disagreement, the Norwegian text applies.",
    "noticeTitle": "Fishing terms for the river system",
    "noticeBody": "Fishing terms have been set for this river system and you have not accepted them yet. They apply wherever you bought your fishing licence. You can still register your catch.",
    "readAndAccept": "Read and accept the terms",
    "acceptNow": "I accept the terms",
    "acceptFailed": "Could not save your acceptance. Please try again."
  },
  "checkin": {
    "intro": "Fishing now? Start fishing so the river association can see how much fishing time is behind the catches.",
    "start": "Start fishing now",
    "end": "Done fishing",
    "active": "You are fishing at {{vald}}",
    "endFailed": "could not end",
    "pickVald": "Choose a vald below first.",
    "privacy": "We only store times, not your location.",
    "sessions": {
      "title": "Your sessions",
      "intro": "Forgot to tap “Start fishing” or “Done fishing”? Add or correct the session here. Times are self-reported, and you can add sessions from the last 60 days (at most 14 hours each).",
      "empty": "No sessions yet.",
      "add": "Add session",
      "edit": "Edit",
      "delete": "Delete",
      "confirmDelete": "Delete this session?",
      "vald": "Vald",
      "start": "Start",
      "end": "End",
      "save": "Save",
      "cancel": "Cancel",
      "running": "In progress",
      "unknown": "Duration unknown: fix the session",
      "manual": "entered manually",
      "hm": "{{h}} h {{m}} min",
      "errors": {
        "end_before_start": "The end must be after the start.",
        "too_long": "A session can be at most 14 hours.",
        "in_future": "The time cannot be in the future.",
        "too_old": "You can only add sessions from the last 60 days.",
        "overlap": "This session overlaps another of your sessions.",
        "open_session": "End the session with “Done fishing” instead.",
        "end_required": "Enter when the session ended.",
        "vald_not_found": "Vald not found.",
        "generic": "Could not save the session. Please try again."
      }
    }
  },
  "elvekort": {
    "notFound": "Elvekort not found.",
    "voluntary": "The elvekort is voluntary. You do not need it to buy a fiskekort or to report a catch.",
    "buy": "Buy elvekort",
    "validPeriod": "Valid {{from}} – {{to}}",
    "myCards": "My elvekort",
    "offerTitle": "Elvekort for the river system",
    "confirmedTitle": "Elvekort purchased",
    "cancelledTitle": "The payment was cancelled",
    "processing": "Processing payment…",
    "pendingHint": "The payment is not confirmed yet. Check “My elvekort” shortly."
  },
  "riversPage": {
    "metaTitle": "Rivers and beats – salmon rivers in Norway | Lakseborsen",
    "metaDescription": "Overview of salmon rivers and beats with fishing permits, season and accommodation.",
    "title": "Rivers and beats",
    "intro": "Every river on Lakseborsen with the beats in each. Pick a river for season, rules, accommodation and places to eat nearby.",
    "closed": "Temporarily closed",
    "valds": "Beats",
    "seeRiver": "See {{river}}",
    "aboutRiver": "About the river",
    "valdsCount": "{{count}} beats"
  }
}
